let Congratulations = {
    openCongratulation: function(e){
        e.preventDefault();

        $('body').addClass('open-director-congrats');
        setTimeout(function(){
            $('body').addClass('bg-director-congrats');
        }, 100);
    },
    closeCongratulation: function(e){
        $('body').removeClass('bg-director-congrats');
        setTimeout(function(){
            $('body').removeClass('open-director-congrats');
        }, 300);
    }
}

$(document).ready(function($) {
    let linkCongratulationDirector = $('[data-head-congratulations-link]');
    if ( linkCongratulationDirector.length ) {

        linkCongratulationDirector.on('click', function(e){
            Congratulations.openCongratulation(e);
        });
    }

    let btnCloseInfoDirectorAbout = $('[data-head-congratulations-close]');
    if (btnCloseInfoDirectorAbout.length) {

        btnCloseInfoDirectorAbout.on('click', function(e){
            Congratulations.closeCongratulation(e);
        });
    };

    $(document).on('click', function(e){
        let _target = $(e.target);

        if( _target.closest('.top-head-banner').length) {
            return;
        }
        e.stopPropagation();

        Congratulations.closeCongratulation(e);
    });

});


// WEBPACK FOOTER //
// ./components/congratulation.js